
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowShowersDay as ObiLightSnowShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-showers-day.js';
 
 
 

 
 export const ObiLightSnowShowersDay = createComponent({
   react: React,
   tagName: 'obi-light-snow-showers-day',
   elementClass: ObiLightSnowShowersDayElement,
   events: {
     
   }
  });
 
 